import { Box, Heading } from '@chakra-ui/react';
import React from 'react';

// The main header + subheader of our page body
export const PageHeader = ({
  headerLabel,
  subheaderLabel,
  marginBottom,
}: {
  headerLabel: React.ReactNode;
  subheaderLabel?: string;
  marginBottom?: string;
}) => {
  return (
    <Box mb={marginBottom}>
      <Heading
        as="h4"
        fontSize={{ base: '16px', sm: '18px', md: '26px' }}
        fontWeight="normal"
      >
        {headerLabel}
      </Heading>
      {subheaderLabel && (
        <Heading
          as="h6"
          fontSize={{ base: '14px', sm: '14px', md: '16px' }}
          m="30px 0"
          fontWeight="normal"
        >
          {subheaderLabel}
        </Heading>
      )}
    </Box>
  );
};
